import React, { Component } from "react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZTime } from "IZOX/STATIC";
import { HStack, Spacer, VStack, XButton, XDiv, XImage, XScroll, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PAContainer from "../shared/PAContainer/PAContainer";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class PAMonthlyPaymentM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      range: {
        from: ZTime.Now().toISOString(),
        to: ZTime.Now().toISOString()
      }
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetAvailableRange();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAMonthlyPaymentM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(PAMonthlyPaymentM.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  renderHeader(){
    return (
      <VStack mB={12} fullWidth HAlign="[" spacing={12}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "Monthly Payment",
            TC: "每月付款"
          })}
        </XText>
      </VStack>
    );
  }

  GetAvailableRange = async () => {
    let res = await ReqX.SendBE("/CMS/SYSAgentReport/Get");
    let {Success, payload} = res;
    if(Success){
      this.setState({
        range: payload
      });
    }
  }

  DownloadPDF = async (date) => {
    try{
      GFunc.Loading(true);
      let res = await ReqX.SendBE("/Web/Agent/GetMonthlyReport", {
        date
      });
      let { Success, payload } = res;
      if (Success) {
        let {url} = payload;
        if(url){
          window.open(url);
        }else{
          GFunc.Alert(payload, "error");
        }
      }
    }catch{

    }finally{
      GFunc.Loading(false);
    }
  }

  renderBtn(date){
    return (
      <XButton onPress={() => this.DownloadPDF(date)} fullWidth
        key={date} bgColor={ColorX.CSS("NotQuiteWhite")}>
        <HStack pH={20}>
          <XText>
            {ZTime.Moment(date).format("MMM YYYY")}
          </XText>
          <Spacer/>
          <XDiv p={5} round={50} fitWidthToContent bgColor={ColorX.CSS("pureWhite")}>
            <XImage source={"/Images/Icons/download.png"}/>
          </XDiv>
        </HStack>
      </XButton>
    );
  }

  renderBtns(){
    let {range} = this.state;
    let months = ZTime.SplitIntoMonths(range.from, range.to);
    months = _.reverse(months);
    // Group months by year
    let monthsByYear = _.groupBy(months, (date) => ZTime.Moment(date).format("YYYY"));
    let yearKeys = Object.keys(monthsByYear);
    yearKeys = _.reverse(yearKeys);

    return (
      <XScroll bgColor={ColorX.CSS("pureWhite")} p={20} fullWidth>
        <VStack fullWidth spacing={12}>
          {_.map(yearKeys, year => (
            <VStack key={year} fullWidth spacing={16}>
              <HStack HAlign="[">
                <XText bold fontSize={14} mT={year !== Object.keys(monthsByYear)[0] ? 16 : 0}>
                  {year}
                </XText>
              </HStack>
              {_.map(monthsByYear[year], (o, i) => this.renderBtn(o, i))}
              <XDiv h={1} bgColor={ColorX.CSS("Cloud")} mV={8} />
            </VStack>
          ))}
        </VStack>
      </XScroll>
    );
  }

  render(){
    return (
      <PAContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
          {this.renderHeader()}
          {this.renderBtns()}
        </VStack>
      </PAContainer>
    );
  }

}

export default PAMonthlyPaymentM;
